import type { TaskRecord } from "@nexus/contracts";

/** Set-generation task types whose completion is shown in the task-progress sidebar. */
export const SET_GENERATION_TASK_TYPES = [
  "generate-opportunity-set",
  "generate-persona-opportunity-set",
] as const;

/**
 * Skip Sonner completion toasts when the unified task-progress channel already
 * owns this set's generation lifecycle (sidebar card + header indicator).
 */
export function shouldSuppressSetGenerationToast(
  activeTasks: readonly TaskRecord[],
  setId: string,
): boolean {
  return activeTasks.some(
    (task) =>
      SET_GENERATION_TASK_TYPES.includes(
        task.type as (typeof SET_GENERATION_TASK_TYPES)[number],
      ) && task.navigation?.params?.setId === setId,
  );
}
